<div *ngIf="games && games.length;">
  <div class="container-sm px-0 text-center" *ngFor="let chunk of (games | chunkify);">
    <div class="row g-2 mb-2">
      <div class="col-12 col-md-6">
        <div class="row g-2 mb-2">
          <div class="col-8" *ngIf="chunk[0]">
            <app-game-item [game]="chunk[0]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
          <div class="col-4">
            <div class="row g-2">
              <div class="col-12" *ngIf="chunk[1]">
                <app-game-item [game]="chunk[1]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
              </div>
              <div class="col-12" *ngIf="chunk[2]">
                <app-game-item [game]="chunk[2]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-2">
          <div class="col-4" *ngIf="chunk[3]">
            <app-game-item [game]="chunk[3]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
          <div class="col-4" *ngIf="chunk[4]">
            <app-game-item [game]="chunk[4]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
          <div class="col-4" *ngIf="chunk[5]">
            <app-game-item [game]="chunk[5]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="row g-2 mb-2">
          <div class="col-4" *ngIf="chunk[6]">
            <app-game-item [game]="chunk[6]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
          <div class="col-4" *ngIf="chunk[7]">
            <app-game-item [game]="chunk[7]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
          <div class="col-4" *ngIf="chunk[8]">
            <app-game-item [game]="chunk[8]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
        </div>
        <div class="row g-2">
          <div class="col-4">
            <div class="row g-2">
              <div class="col-12 " *ngIf="chunk[9]">
                <app-game-item [game]="chunk[9]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
              </div>
              <div class="col-12" *ngIf="chunk[10]">
                <app-game-item [game]="chunk[10]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
              </div>
            </div>
          </div>
          <div class="col-8" *ngIf="chunk[11]">
            <app-game-item [game]="chunk[11]" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

